// extracted by mini-css-extract-plugin
module.exports = {"chartTooltip":"style__chartTooltip__Fg3iW","legend":"style__legend__-BLs4","legendTag":"style__legendTag__full-","colorSwatch":"style__colorSwatch__ZML1K"};